// the colour of a need's bar: low is red, middling orange, fine the brand colour (all palette tokens)
export const needColour = (value: number) =>
  value < 25 ? 'var(--ll-danger)' : value < 50 ? 'var(--ll-orange)' : 'var(--primary)';
